import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import { getDrugTestThemeTokens } from '../themeTokens';

export const ErrorRoot = styled('div')(({ theme }) => {
  const t = getDrugTestThemeTokens(theme);
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 12,
    padding: '16px 18px',
    borderRadius: 8,
    background: t.errorBg,
    border: `1px solid ${t.errorBorder}`,
    color: t.errorText,
  };
});

export const ErrorTitle = styled('p')({
  margin: 0,
  fontSize: 13,
  fontWeight: 700,
});

export const ErrorMessage = styled('p')({
  margin: 0,
  fontSize: 13,
  lineHeight: 1.45,
});

export const RetryButton = styled(Button)(({ theme }) => {
  const t = getDrugTestThemeTokens(theme);
  return {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 13,
    padding: '4px 12px',
    borderRadius: 8,
    borderColor: t.errorBorder,
    color: t.errorText,
    background: t.surface,
    '&:hover': {
      borderColor: t.errorBorder,
      background: t.surface,
      filter: 'brightness(0.97)',
    },
  };
});
